import { t } from 'i18next';

export const GET_TRANSLATION_STATUS_LABEL_MAP = () =>
  ({
    not_saved: t('generic:status.not_saved'),
    archived: t('generic:status.archived'),
    draft: t('generic:status.draft'),
    pending_translation: t('generic:status.pending_translation'),
    pending_validation: t('generic:status.pending_validation'),
    'waiting-translation': t('generic:status.pending_translation'),
    'waiting-validation': t('generic:status.pending_validation'),
    ready: t('generic:status.ready'),
    validated: t('generic:status.validated'),
  } as const);
